type ErrorType =
    | 'CircleRsvpSuccessful'
    | 'CircleNotFoundError'
    | 'CircleValidationError'
    | 'CircleProcessingError'
    | 'CircleSessionSeatLimitExceededError'
    | 'CirclePermissionDeniedError'
    | 'CircleRsvpForSessionExistsForUserError'
    | 'CircleSessionAlreadyStartedError';

export const getErrorMessage = (type?: ErrorType | undefined): string => {
    const defaultErrorMessage =
        'An error occurred. If this persists, please reach out to help@modernhealth.com';
    if (!type) return defaultErrorMessage;
    const messagesDict: Record<string, string> = {
        CircleSessionAlreadyStartedError: 'Session already started, please select another session',
        CircleSessionSeatLimitExceededError: 'Session fully booked, please select another session',
        CircleRsvpForSessionExistsForUserError:
            'RSVP for this session already exists, please select another session',
    };
    return messagesDict[type] ?? defaultErrorMessage;
};
